import React, {Component} from "react";
import apiClient from "api/client";
import DualListBox from 'react-dual-listbox';
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
//import {css} from "emotion";
import {css} from "@emotion/core";
import {BeatLoader} from "react-spinners";

//https://github.com/jakezatecky/react-dual-listbox
//https://github.com/jakezatecky/react-dual-listbox/issues/41

const override = css`
    position: absolute;
    left: 47%;
    top: 30%;
    display: block;
    z-index: 1000;
`;


class DualListBoxPackageLive extends Component {

    constructor(props) {
        super(props);

        this.handleChannelSelect = this.handleChannelSelect.bind(this);

        this.state = {
            loading: false,

            availableChannels: [],
            selectedArray: []
        };
        this.onChange = this.onChange.bind(this);

    }

    handleChannelSelect(selected) {
        this.props.handlerFromParent(selected);
    }

    onChange(selected) {

        this.setState({selectedArray: selected});
        this.handleChannelSelect(selected)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.livePackageProvider !== prevProps.livePackageProvider) {
            this.loadAvailableChannelsFromMiddleware()
        }

    }

    componentDidMount() {
        this.loadAvailableChannelsFromMiddleware();
    }

    loadAvailableChannelsFromMiddleware() {

        let url = "";

        if (this.props.livePackageProvider === null) {
            url = process.env.REACT_APP_API_URL + "/LivePackage/channels";
        } else {
            url = process.env.REACT_APP_API_URL + "/LivePackage/channels?provider=" + this.props.livePackageProvider;
        }

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };


        apiClient.get(url, axiosConfig)
            .then(res => {

                let temp = res.data;

                let availableChannels = [];
                let obj = {};

                for (let i = 0; i < temp.length; i++) {
                    //console.log(temp[i].value.toString())

                    obj = {
                        value: temp[i].value.toString(),
                        label: temp[i].label

                    }
                    availableChannels.push(obj)
                }

                const loading = false;

                this.setState({availableChannels, loading});
            })
            .catch(error => {
                console.log(error);
                this.props.dispatch(userActions.logoutUnauthorized());
            });

    }

    render() {
        return (
            <div>

                <div className="sweet-loader">
                    <BeatLoader
                        css={override}
                        size={5}
                        color={'#2c67a4'}
                        loading={this.state.loading}
                        //loading={true}
                    />
                </div>

                <DualListBox
                    options={this.state.availableChannels}
                    canFilter
                    availableLabel={"Available"}
                    selectedLabel={"Selected"}
                    showHeaderLabels
                    simpleValue={true}
                    selected={this.props.channelsInPackage}
                    onChange={this.onChange}
                />
            </div>
        );
    }
}


function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDualListBoxPackageLive = connect(mapStateToProps)(DualListBoxPackageLive);
const connectedDualListBoxPackageLiveTrans = withNamespaces('common')(connectedDualListBoxPackageLive);
export {connectedDualListBoxPackageLiveTrans as DualListBoxPackageLive};
